import Price from '@link/share/components/Price';
import type { PlanPriceProps } from './PlanPrice.types';
import styles from './planPrice.module.css';

/**
 * 大人 ¥3,000 — a plan's starting price and the unit it is for.
 *
 * Its container colours, sizes and spaces it through
 * `--plan-price-label-color`, `--plan-price-gap` and Price's own
 * `--price-primary-*` properties.
 */
const PlanPrice = ({ label, amount, currency }: PlanPriceProps) => (
  <div className={styles.price}>
    {label && <span className={styles.label}>{label}</span>}
    <Price amount={amount} currencyCode={currency} />
  </div>
);

export default PlanPrice;
